import React from 'react';

import ColAtm from "../../../../atomic/Col/Col";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {Animated} from "react-animated-css";
import AddonBox from "./AddonBox"
import {connect} from "react-redux";
import {updateFactClearState} from "../../../../../redux/actions/Content/FactList/factListActions";
import ErrorModal from "../../../../organisms/Modal/ErrorModal/ErrorModal";



class AddonBoxes extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            checkedStatus: true
        }
    }

    showMessage = () => {

        if(this.props.updateFactMappingReducerError?.response?.status === 400)
        {
            let message = this.props.updateFactMappingReducerError?.response.data.message
            return  <ErrorModal status={true} message={message}/>
        }

    }

    componentWillUnmount() {
        this.props.updateFactClearState();
    }


    render() {
        return (
            <ColAtm>
                {
                    this.props.get_addons.map( (addon) => (

                        !this.props.fetching &&
                        <Animated className="fact-col" animationIn="bounceInRight" animationInDuration={1000} isVisible={true}>
                            <AddonBox
                                addon={addon}
                                isSelected={addon.is_selected}
                                pageId={this.props.pageId}
                                descriptionData={this.props.descriptionData}
                            />
                        </Animated>
                    ))
                }
                {
                    this.showMessage()
                }
            </ColAtm>
        )
    }
}


const mapStateToProps = (props) => {
    return {
        updateFactMappingReducerError : props.updateFactMappingReducer?.error,
    }
};

export default compose(withTranslation('common'))(connect(mapStateToProps, { updateFactClearState } )(AddonBoxes));
